import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import FlashSalesOne from "../components/FlashSalesOne";
import ProductListOne from "../components/ProductListOne";
import OfferOne from "../components/OfferOne";
import RecommendedOne from "../components/RecommendedOne";
import HotDealsOne from "../components/HotDealsOne";
import NewArrivalOne from "../components/NewArrivalOne";
import ShippingOne from "../components/ShippingOne";
import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import SEO from "../components/SEO";

const HomePageOne = () => {

  // const [selectedCurrency, setSelectedCurrency] = useState(
  //   localStorage.getItem("selectedCurrency")
  // );
  const [selectedCurrency, setSelectedCurrency] = useState(
  localStorage.getItem("selectedCurrency") || "USD"
);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

//   const detectCurrency = async (setSelectedCurrency) => {
//   try {
//     const res = await fetch("https://ipapi.co/json/");
//     const data = await res.json();

//     let currency = "USD";

//     if (data.country_code === "IN") currency = "INR";
//     else if (data.country_code === "AE") currency = "AED";

//     localStorage.setItem("selectedCurrency", currency);
//     setSelectedCurrency(currency);

//   } catch (error) {
//     console.error("Currency detect error:", error);
//     localStorage.setItem("selectedCurrency", "USD");
//     setSelectedCurrency("USD");
//   }
// };

const detectCurrency = async (
  setSelectedCurrency
) => {

  try {

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/product/detect-currency`
    );

    const data = await res.json();

    const currency =
      data.currency || "USD";

    localStorage.setItem(
      "selectedCurrency",
      currency
    );

    setSelectedCurrency(currency);

  } catch (error) {

    console.error(
      "Currency detect error:",
      error
    );

    localStorage.setItem(
      "selectedCurrency",
      "USD"
    );

    setSelectedCurrency("USD");
  }
};

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    localStorage.setItem("selectedCurrency", currency); 
  };

  useEffect(() => {
  if (!localStorage.getItem("selectedCurrency")) {
    detectCurrency(setSelectedCurrency);
  }
}, []);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (

    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop — show only on desktop */}
      {/* {isDesktop && <ScrollToTop smooth color="#e54b24" />} */}
      {/* <ScrollToTop smooth color="#1E293B" /> */}

      {/* ColorInit */}
      <ColorInit color={true} />

      {/* HeaderOne */}
      <HeaderOne selectedCurrency={selectedCurrency} handleCurrencyChange={handleCurrencyChange} />

      {/* BannerOne */}
      <BannerOne />

      {/* FlashSalesOne */}
      <FlashSalesOne />

      {/* ProductListOne */}
      <ProductListOne selectedCurrency={selectedCurrency} />

      {/* OfferOne */}
      <OfferOne />

      {/* RecommendedOne */}
      <RecommendedOne selectedCurrency={selectedCurrency} />

      {/* HotDealsOne */}
      <HotDealsOne selectedCurrency={selectedCurrency} />

      {/* NewArrivalOne */}
      <NewArrivalOne selectedCurrency={selectedCurrency} />

      {/* ShippingOne */}
      <ShippingOne />

      {/* NewsletterOne */}
      <NewsletterOne />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      {/* <BottomFooter /> */}

    </>
  );
};

export default HomePageOne;
